import React from 'react'
import { useMappingStats } from '../../../../../features/groupCustomerMapping/queries/useMappingStats'
import { useMappingCompanies } from '../../../../../features/groupCustomerMapping/queries/useMappingCompanies'
import { useGroupSourceMaps } from '../../../../../features/groupCustomerMapping/queries/useGroupSourceMaps'
import OnboardingWizard from '../../../../../features/groupCustomerMapping/components/OnboardingWizard'
import Loading from '../../../../../shared/components/Loading'
import RequestError from '../../../../../shared/components/RequestError'

const CustomerMappingWizard: React.FC = () => {
  const { companies, sourceMaps, groupCompany, isCompaniesLoading, isSourceMapsLoading, isError } = useMappingStats()
  const { refetch: refetchCompanies } = useMappingCompanies()
  const { refetch: refetchSourceMaps } = useGroupSourceMaps(companies.map(company => company.id))

  if (isCompaniesLoading) return <Loading />
  if (isError) return <RequestError error="" refetch={() => Promise.all([refetchCompanies(), refetchSourceMaps()])} />

  return (
    <OnboardingWizard
      companies={companies}
      sourceMaps={sourceMaps}
      groupCompanyId={groupCompany?.id}
      loading={isSourceMapsLoading}
    />
  )
}

export default CustomerMappingWizard
